export default __webpack_public_path__ + "bbc0c47b6b040f8fb2c919179b983d1d.svg";